import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AccountItem } from '../models/accountitem';
import { IToasterInput } from '../models/interfaces';


@Injectable()
export class InternalMsgService {
    private loggedInAccountSource = new Subject<AccountItem>();
    loggedInAccountSet$ = this.loggedInAccountSource.asObservable();    
    onLoggedInAccountSet( account: AccountItem ) {
        this.loggedInAccountSource.next( account );
    }
    
    private selectedMenuSource = new Subject<number>();
    selectedMenuSet$ = this.selectedMenuSource.asObservable();    
    onSelectedMenuSet( index: number ) {
        this.selectedMenuSource.next( index );
    }
    
    private readyForActionSource = new Subject<boolean>();
    readyForActionSet$ = this.readyForActionSource.asObservable();    
    onreadyForActionSet( ready: boolean ) {
        this.readyForActionSource.next( ready );
    }

    private showToasterSource = new Subject<IToasterInput>();
    showToasterSet$ = this.showToasterSource.asObservable();    
    onShowToasterSet(input: IToasterInput): void {
        this.showToasterSource.next(input);
    }
            
    private toggleSpinnerSource = new Subject<boolean>();
    toggleSpinnerSet$ = this.toggleSpinnerSource.asObservable();    
    ontoggleSpinnerSet(toggle: boolean): void {
        this.toggleSpinnerSource.next(toggle);
    }  
}

